import Vue from 'vue'
import Router from 'vue-router'

import HomeLayout from '@/views/layout/HomeLayout'
import PageLayout from '@/views/layout/PageLayout'
import ProductLayout from '@/views/layout/ProductLayout'
import ProjectLayout from '@/views/layout/ProjectLayout'
import SolutionLayout from '@/views/layout/SolutionLayout'
import Home from '@/views/pages/Home'
import Contact from '@/views/pages/Contact'
import Team from '@/views/pages/Team'
import Technology from '@/views/pages/Technology'
import Project from '@/views/pages/Project'
import Solution from '@/views/pages/Solution'
import SoftwareDesignDevelopment from '@/views/pages/product/SoftwareDesignDevelopment'
import PackagedSoftware from '@/views/pages/product/PackagedSoftware'
import InDepthTrainingConsulting from '@/views/pages/product/InDepthTrainingConsulting'
import ProjectLayouts from '@/views/pages/project/ProjectLayout'
import TimeStore from '@/views/pages/project/TimeStore'
import TimebitDefi from '@/views/pages/project/TimebitDefi'
import TimebirdExchange from '@/views/pages/project/TimebirdExchange'
import Explorer from '@/views/pages/project/Explorer'
import PortalAPIServices from '@/views/pages/project/PortalAPIServices'
import TimebirdEKYC from '@/views/pages/project/TimebirdEKYC'
import TimebirdTrade from '@/views/pages/project/TimebirdTrade'
import TBCScan from '@/views/pages/project/TBCScan'

Vue.use(Router)

const routes = [
  {
    path: '/',
    component: HomeLayout,
    redirect: { name: 'Home' },
    children: [
      {
        path: '',
        name: 'Home',
        component: Home,
        meta: {title: 'About Us' }
      },
      {
        path: 'product',
        component: ProductLayout,
        meta: {title: 'Product'},
        redirect: {name: 'SoftwareDesignDevelopment'},
        children: [
          {
            path: 'software-design-development',
            name: 'SoftwareDesignDevelopment',
            component: SoftwareDesignDevelopment,
            meta: {title: 'Software Design & Development'}
          },
          {
            path: 'packaged-software',
            name: 'PackagedSoftware',
            component: PackagedSoftware,
            meta: {title: 'Packaged Software'}
          },
          {
            path: 'in-depth-training-consulting',
            name: 'InDepthTrainingConsulting',
            component: InDepthTrainingConsulting,
            meta: {title: 'In-depth Training & Consulting'}
          }
        ]
      },
    ]
  },
  {
    path: '/',
    component: PageLayout,
    children: [
      {
        path: 'contact',
        component: Contact,
        name: 'Contact',
        meta: {title: 'Contact'}
      },
      {
        path: 'team',
        component: Team,
        name: 'Team',
        meta: {title: 'Team'}
      },
      {
        path: 'solution',
        component: Solution,
        meta: {title: 'Solution'},
        name: 'Solution'
      },
      {
        path: 'technology',
        component: Technology,
        name: 'Technology',
        meta: {title: 'Technology'}
      },
      {
        path: 'project',
        name: 'Project Parent',
        component: ProjectLayouts,
        meta: {title: 'Projects'},
        redirect: {name: 'Projects'},
        children: [
          {
            path: '',
            name: 'Projects',
            component: Project,
            meta: {title: 'Projects'}
          },
          {
            path: 'timestore',
            name: 'TimeStore',
            component: TimeStore,
            meta: {title: 'TimeStore'}
          },
          {
            path: 'timebit-defi',
            name: 'Timebit Defi',
            component: TimebitDefi,
            meta: {title: 'Timebit Defi'}
          },
          {
            path: 'timebird-exchange',
            name: 'Timebird Exchange',
            component: TimebirdExchange,
            meta: {title: 'Timebird Exchange'}
          },
          {
            path: 'explorer',
            name: 'Explorer',
            component: Explorer,
            meta: {title: 'Explorer'}
          },
          {
            path: 'portal-api-services',
            name: 'Portal API Services',
            component: PortalAPIServices,
            meta: {title: 'Portal API Services'}
          },
          {
            path: 'timebird-ekyc',
            name: 'TimeBird eKYC',
            component: TimebirdEKYC,
            meta: {title: 'TimeBird eKYC'}
          },
          {
            path: 'timebird-trade',
            name: 'TimeBird Trade',
            component: TimebirdTrade,
            meta: {title: 'TimeBird Trade'}
          },
          {
            path: 'tbc-scan',
            name: 'TBC Scan',
            component: TBCScan,
            meta: {title: 'TBC Scan'}
          },
        ]
      },
      {
        path: '*',
        redirect: '/'
      }
    ]
  }
]

// Router catch exception
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location)
    .catch(() => console.log('Routing is not changed'))
}

export default new Router({
  mode: 'history',
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: routes
})
